import Vue from "vue";
import VueRouter from "vue-router";
import VueSocketIO from "vue-socket.io";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/dashboard/waterlevel",
    name: "Dashboard ",
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/dashboard/pumps-1",
    name: "Dashboard Pumps",
    component: () => import("../views/DashboardPumps1.vue"),
  },
  {
    path: "/dashboard/pumps-2",
    name: "Dashboard Pumps2",
    component: () => import("../views/DashboardPumps2.vue"),
  },
  {
    path: "/livedata-pump1/:imeino",
    name: "Dashboard",
    component: () => import("../views/LivedataPump1.vue"),
    beforeEnter(to, from, next) {
      if (!Vue.prototype.$socket) {
        Vue.use(
          new VueSocketIO({
            debug: true,
            connection: "http://:32281",
          })
        );
      }
      next();
    },
  },
  {
    path: "/livedata-pump2/:imeino",
    name: "Dashboard",
    component: () => import("../views/LivedataPump2.vue"),
    beforeEnter(to, from, next) {
      if (!Vue.prototype.$socket) {
        Vue.use(
          new VueSocketIO({
            debug: true,
            connection: "http://216.10.247.24:32281",
          })
        );
      }
      next();
    },
  },
  {
    path: "/device-data/:imeino",
    name: "Dashboard",
    component: () => import("../views/DeviceRecord.vue"),
  },
  {
    path: "/main",
    name: "Dashboard",
    component: () => import("../views/Main.vue"),
  },
  {
    path: "/users",
    name: "Users",
    component: () => import("../views/Users.vue"),
  },
  {
    path: "/reports/level",
    name: "Reports",
    component: () => import("../views/LevelReport.vue"),
  },
  {
    path: "/reports/pump",
    name: "Reports adasdasdasdasdasdasasd",
    component: () => import("../views/PumpReport.vue"),
  },
  {
    path: "/reports/daily-operational-report",
    name: "Reports daily operational report",
    component: () => import("../views/daily-operational-report.vue"),
  },
  {
    path: "/reports/operational-report",
    name: "Reports operational report",
    component: () => import("../views/operational-report.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Logout.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
